import styled from 'styled-components';

export const NurseryDetails = styled.div`

`
